import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'

import { TRFPDocument } from 'features/RFP/RFPDetails/types'
import { useRFPDetailsContext } from 'features/RFP/RFPDetails/Providers/RFPDetailsContextProvider'
import { RFP_STATUSES } from 'features/RFP/constants'
import { DOCUMENT_TYPE } from 'components/FileUpload/constants'

type ContextProps = {
  state: {
    isVotingInProgress: boolean
    templateFiles: TRFPDocument[]
    summaryPriceFiles: TRFPDocument[]
  }
  actions: {}
}

const RFPVotingContext = createContext<ContextProps>({
  state: {} as ContextProps['state'],
  actions: {} as ContextProps['actions']
})

const RFPVotingContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const rfpDetailsContext = useRFPDetailsContext()

  const { data } = rfpDetailsContext.state
  const { getDocumentsByType } = rfpDetailsContext.actions

  const isVotingInProgress =
    data.status === RFP_STATUSES.VOTING_IN_PROGRESS ||
    data.status === RFP_STATUSES.VENDORS_SELECTION

  const state = useMemo(
    () => ({
      isVotingInProgress,
      templateFiles:
        data?.autogenerated_default_documents.filter(
          (i) => i.document_type === 'executive_summary'
        ) || [],
      summaryPriceFiles: getDocumentsByType(DOCUMENT_TYPE.EXECUTIVE_SUMMARY)
    }),
    [
      data?.autogenerated_default_documents,
      getDocumentsByType,
      isVotingInProgress
    ]
  )

  const actions = useMemo(() => ({}), [])

  return (
    <RFPVotingContext.Provider value={{ state, actions }}>
      {children}
    </RFPVotingContext.Provider>
  )
}

export const useRFPVotingContext = () => useContext(RFPVotingContext)

export default RFPVotingContextProvider
